import {ComponentProps} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/outerOrder";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import Divider from "../../../../components/Divider";
import {Link} from "react-router-dom";
import {Button, message, Space} from "antd";
import withAuth from "../../../../utils/withAuth";
import {useRequest} from "ahooks";
import dayjs from "dayjs";
import {OuterOrderHeaderStatusMapping, OuterOrderHeaderStatusOptions} from "../../../../utils/constants";


const PullOrderButton = withAuth('pullOrder', Button);
const UploadSupplyButton = withAuth('uploadSupply', Button);

function MeinianNewOrder(props: ComponentProps<any>) {

    const {tableProps, search, form,} = useAntTable(api.getMeinianNewOrders, {});

    const {loading: loadingPullOrder, run: runPullOrder} = useRequest(api.meinianNewPullOrderJob, {
        manual: true,
        onSuccess(res){
            message.success('执行成功');
        }
    });
    const { loading: loadingUploadSupply, run: runUploadSupply} = useRequest(api.meinianNewUploadsSupplyOrderJob, {
        manual: true,
        onSuccess(res){
            message.success('执行成功');
        }
    })

    const columns: StandardColumnsType = [
        {
            dataIndex: 'orderNumber',
            key: 'orderNumber',
            title: '外部单号'
        },
        {
            dataIndex: 'externalCustomerName',
            key: 'externalCustomerName',
            title: '客户名称',
            search: true
        },
        {
            dataIndex: 'orderDate',
            key: 'orderDate',
            title: '订单日期',
            render(v){
                return v && dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'totalAmount',
            key: 'totalAmount',
            title: '订单合计'
        },
        {
            dataIndex: 'qty',
            key: 'qty',
            title: '数量'
        },
        {
            dataIndex: 'status',
            key: 'status',
            title: '状态',
            render(v){
                return OuterOrderHeaderStatusMapping[v]
            }
        },
        {
            dataIndex: 'operation',
            key: 'operation',
            title: '操作',
            render(v, r: any, i) {
                return <Divider>
                    <Link to={`/api/meinian/new/detail/${r.id}`}>详情</Link>
                </Divider>
            }
        }
    ];

    const searchColumns:StandardColumnsType = [
        {
            dataIndex: 'orderNumber',
            title: '订单编号',
            search: true
        },
        {
            dataIndex: 'status',
            title: '状态',
            search: {
                valueEnum: OuterOrderHeaderStatusOptions,
                valueType: 'select'
            }
        }
    ];

    const toolbar = (
        <Space>
            <PullOrderButton loading={loadingPullOrder} type={"primary"} onClick={runPullOrder}>同步订单</PullOrderButton>
            <UploadSupplyButton loading={loadingUploadSupply} type={"primary"} onClick={runUploadSupply}>同步出库</UploadSupplyButton>
        </Space>
    );

    return <PageHeaderLayout>
        <StandardTable {...tableProps} submit={search.submit} columns={columns} form={form} toolbar={toolbar} search={search} extSearchColumns={searchColumns}/>
    </PageHeaderLayout>
}

export default MeinianNewOrder;
